import { takeEvery } from "redux-saga/effects"
import { findIndex, pick, pullAt } from "lodash"
import { Types } from "model/data"

// [TODO] don't we have a better way to do this?
export function handleSetValue(action) {
  switch (action.type) {
    case Types.LOAD_SUCCESS:
      if (action.resource === "portfolio") {
        const accountValue = action.id.split("/")[2]
        const key = `OP_${accountValue}_LastPortfolios`
        const portfolio = action.data
        const lastPortfolios = JSON.parse(localStorage.getItem(key)) || []
        const index = findIndex(lastPortfolios, p => p.id === portfolio.id)

        // if not first and in array, remove it.
        if (index > 0) {
          pullAt(lastPortfolios, index)
        }

        // if not the first one, insert it.
        if (index !== 0) {
          lastPortfolios.unshift(pick(portfolio, ["name", "id", "shortId"]))
        }

        // if array is now over limit, remove last entry
        if (lastPortfolios.length > 10) {
          lastPortfolios.pop()
        }

        localStorage.setItem(key, JSON.stringify(lastPortfolios))
      }
      break
  }
}

export default function* setLocalStoreValue() {
  yield takeEvery([
    Types.LOAD_SUCCESS,
  ], handleSetValue)
}
